const ru = {
  home: {
    hero: {
      alt: 'Логотип Panch Tatva',
      tagline: 'Тихое исследование равновесия, присутствия и пяти элементов.',
      cta: 'Войти в элементы',
    },
    collection: {
      title: 'Элементы',
      description:
        'Каждый элемент отражает состояние бытия — выраженное через форму, текстуру и намерение.',
    },
    about: {
      title: 'Наша философия',
      paragraphs: [
        'Panch Tatva — это философия, основанная на понимании того, что равновесие не создаётся — его вспоминают.',
        'Через элементальную осознанность и внимательное творчество эта работа исследует, как повседневные предметы могут поддерживать присутствие, ритм и тихую гармонию в современной жизни.',
      ],
    },
  },
  nav: {
    home: 'Главная',
    shop: 'Магазин',
    about: 'О нас',
    cart: 'Корзина',
    logoAlt: 'Логотип Panch Tatva от Anukta',
  },
  footer: {
    brand: 'Panch Tatva',
    tagline: 'Философия элементального равновесия, выраженная через осознанные творения.',
    explore: ['Главная', 'Элементы', 'Философия', 'Ритуалы', 'Магазин'],
    exploreTitle: 'Исследовать',
    contact: {
      email: 'support@panch-tatva.co.in',
      phone: '+91 6390725752',
    },
    contactTitle: 'Контакт',
    legal: [
      '“Panch Tatva by Anukta” — бренд и философия, управляемые Anukta Panchatatva LLP.',
      '© 2026 Panch Tatva by Anukta™. Все права защищены.',
    ],
  },
  card: {
    addToCart: 'Добавить в корзину',
    viewDetails: 'Посмотреть детали',
  },
  cart: {
    title: 'Ваша корзина',
    empty: 'Ваша корзина пуста',
    remove: 'Удалить',
    totalPrefix: 'Итого:',
    checkout: 'Оформить заказ',
    guestBanner: 'Войдите, чтобы сохранить корзину на всех устройствах', // TODO: professional translation
  },
  checkout: {
    guestSignInPrompt: 'Войдите для быстрого оформления заказа', // TODO: professional translation
    // Address section
    shippingAddress: 'Адрес доставки',
    savedAddresses: 'Сохранённые адреса',
    addNewAddress: '+ Добавить новый адрес',
    useThisAddress: 'Использовать этот адрес',
    noSavedAddresses: 'Сохранённые адреса не найдены',
    loadingAddresses: 'Загружаем ваши адреса…',
    addressLoadError: 'Не удалось загрузить сохранённые адреса. Введите вручную.',
    // Address form fields
    fullName: 'Полное имя',
    phone: 'Номер телефона',
    email: 'Email',
    addressLine: 'Адрес',
    city: 'Город',
    state: 'Регион',
    pincode: 'Индекс',
    saveAsDefault: 'Сохранить как адрес по умолчанию',
    // Shipping options section
    deliveryMethod: 'Способ доставки',
    fetchingRates: 'Загружаем тарифы доставки…',
    shippingRatesFor: 'Тарифы для',
    noShippingOptions: 'Для этого индекса нет доступных курьерских служб. Проверьте индекс.',
    shippingFallback: 'Тарифы в реальном времени недоступны — показаны стандартные варианты.',
    shippingApiError: 'Не удалось загрузить тарифы. Используются стандартные варианты.',
    ratesUpdating: 'Обновляем тарифы…',
    pincodeMissing: 'Введите корректный индекс для загрузки тарифов доставки.',
    deliveryDays: 'рабочих дней',
    standardDelivery: 'Стандартная доставка',
    standardDays: '3–5 рабочих дней',
    expressDelivery: 'Экспресс-доставка',
    expressDays: '1–2 рабочих дня',
    reviewOrder: 'Проверить заказ',
    deliveryTo: 'Доставить по адресу:',
    continue: 'Продолжить',
    back: 'Назад',
    payNow: 'Оплатить',
    stepAddress: 'Адрес',
    stepShipping: 'Доставка',
    stepReview: 'Проверка',
    cartEmpty: 'Ваша корзина пуста',
    cartEmptyDesc: 'Добавьте товары перед оформлением заказа',
    continueShopping: 'Продолжить покупки',
    // v2.7 — Feature 33 // TODO: professional translation
    noCoverage: 'Доставка по этому почтовому индексу недоступна.',
    noCoverageDesc: 'Пожалуйста, проверьте индекс или свяжитесь с нами.',
    editAddress: 'Изменить адрес',
    serviceUnavailable: 'Варианты доставки временно недоступны. Показаны стандартные варианты.',
    retryRates: 'Повторить',
    recommended: 'Рекомендуется',
  },
  auth: {
    loading: 'Загрузка...',
    greeting: 'Привет',
    login: 'Войти',
    logout: 'Выйти',
    anonymous: 'Пользователь',
  },
  payment: {
    payPrefix: 'Оплатить',
    verifySuccess: 'Платёж подтверждён и успешен!',
    verifyFail: 'Не удалось подтвердить платёж. Пожалуйста, свяжитесь со службой поддержки.',
    verifyError: 'Ошибка проверки платежа.',
    initiationFail: 'Не удалось инициировать платёж.',
  },
  product: {
    notFound: 'Продукт не найден',
  },
  authPages: {
    loginHeader: 'Войдите, чтобы продолжить',
    loginPrompt: 'Пожалуйста, войдите, чтобы продолжить оплату.',
  },
  shop: {
    title: 'Все продукты',
  },
  products: {
    '1': {
      name: 'Земля',
      description: 'Заземляющие и питающие продукты, созданные из натуральных глин и трав, вдохновлённых мудростью Матери-Земли.',
    },
    '2': {
      name: 'Вода',
      description: 'Успокаивающие продукты, пропитанные водными ароматами и эфирными маслами для уравновешивания эмоций.',
    },
    '3': {
      name: 'Огонь',
      description: 'Бодрящие продукты, чтобы наполнить ваше пространство энергией и огненными ароматами.',
    },
    '4': {
      name: 'Воздух',
      description: 'Создания, вдохновлённые Воздухом, раскрывающие тонкие ароматы по мере того, как вдохновение свободно движется и открываются пути.',
    },
    '5': {
      name: 'Эфир',
      description: 'Создано для мягкого очищения — приглашая ясность, безграничное пространство и невысказанное присутствие в тихой роскоши.',
    },
    '6': {
      name: 'Подарочная коробка Panch Tatva',
      description: 'Кураторская подарочная коробка класса люкс, содержащая все пять элементальных продуктов для полного баланса.',
    },
  },
  profile: {
    header: 'Профиль',
    loadingProfile: 'Загрузка профиля...',
    loadingUserInfo: 'Загрузка информации о пользователе...',
    labels: {
      name: 'Имя',
      email: 'Электронная почта',
      firstName: 'Имя',
      lastName: 'Фамилия',
    },
  },
  quiz: {
    cta: 'Найди свой элемент',
    ctaSubtitle: 'Ответьте на 5 вопросов и узнайте, какой элемент подходит вашей коже.',
    title: 'Найди свой элемент',
    subtitle: 'Ответьте на 5 вопросов, и мы подберём ваш элементальный ритуал.',
    step: 'Шаг',
    of: 'из',
    next: 'Далее',
    back: 'Назад',
    submit: 'Открыть мой элемент',
    loading: 'Читаем элементы…',
    error: 'Что-то пошло не так. Попробуйте ещё раз.',
    questions: {
      skinType: { label: 'Какой у вас тип кожи?', options: { dry: 'Сухая', oily: 'Жирная', combination: 'Комбинированная', sensitive: 'Чувствительная', normal: 'Нормальная' } },
      climate: { label: 'Какой у вас климат?', options: { hot_humid: 'Жаркий и влажный', dry_arid: 'Сухой', cold: 'Холодный', temperate: 'Умеренный' } },
      concern: { label: 'Главная забота о коже?', options: { hydration: 'Увлажнение', acne: 'Акне', anti_aging: 'Омоложение', glow: 'Сияние', soothing: 'Успокоение' } },
      texture: { label: 'Предпочитаемая текстура?', options: { rich: 'Насыщенная', light: 'Лёгкая', solid: 'Твёрдое мыло', none: 'Без предпочтений' } },
      fragrance: { label: 'Какой аромат вам близок?', options: { earthy: 'Земляной', fresh: 'Свежий и цветочный', citrus: 'Цитрусовый', unscented: 'Без аромата' } },
    },
    result: {
      title: 'Ваш элемент',
      secondary: 'с нотками',
      rationale: 'Почему это вам подходит',
      recommendedProducts: 'Ваши элементальные продукты',
      addSet: 'Добавить набор в корзину',
      retake: 'Пройти заново',
      shopAll: 'Все элементы',
      elements: { earth: 'Земля', water: 'Вода', fire: 'Огонь', air: 'Воздух', ether: 'Эфир' },
      elementDescriptions: { earth: 'Земля · Питание · Глубина', water: 'Увлажнение · Прохлада · Нежность', fire: 'Очищение · Энергия · Ясность', air: 'Свежесть · Лёгкость · Свобода', ether: 'Баланс · Утончённость · Чистота' },
    },
  },
  chat: {
    title: 'Татва',
    subtitle: 'Ваш элементальный гид',
    placeholder: 'Задайте любой вопрос…',
    send: 'Отправить',
    loading: 'Думаю…',
    error: 'Не удалось подключиться к Татве. Попробуйте снова.',
    escalatePrompt: 'Хотите, чтобы я создал обращение в поддержку?',
    escalateYes: 'Да, пожалуйста',
    escalateNo: 'Нет, спасибо',
    ticketSuccess: 'Обращение создано. Мы ответим в течение 24 часов.',
    ticketError: 'Не удалось создать обращение. Напишите нам по почте.',
    emailPlaceholder: 'Ваш адрес электронной почты',
    openLabel: 'Чат с Татвой',
    closeLabel: 'Закрыть чат',
  },
  admin: {
    // Dashboard
    dashboard: 'Панель администратора',
    dashboardSubtitle: 'Управляйте операциями Panch Tatva',
    totalRevenue: 'Общий доход',
    totalOrders: 'Всего заказов',
    totalCustomers: 'Всего клиентов',
    pendingActions: 'Ожидающие действия',
    requiresAttention: 'Требует внимания',
    thisMonth: 'В этом месяце',
    allTime: 'Всех времен',
    isActive: 'Активно',
    topProducts: 'Лучшие товары',
    recentOrders: 'Недавние заказы',
    systemHealth: 'Здоровье системы',
    razorpay: 'Razorpay',
    database: 'База данных',

    // Navigation
    products: 'Товары',
    orders: 'Заказы',
    customers: 'Клиенты',
    finance: 'Финансы',
    reconciliation: 'Выверка',
    settings: 'Параметры',
    manage: 'Управлять',

    // Products Page
    manageProducts: 'Добавлять, редактировать, удалять товары и управлять инвентарем',
    manageYourInventory: 'Управляйте инвентарем товаров',
    productName: 'Название товара',
    element: 'Элемент',
    price: 'Цена',
    costPrice: 'Себестоимость',
    quantity: 'Количество',
    warehouseLocation: 'Местоположение склада',
    description: 'Описание',
    imageUrl: 'URL изображения',
    allStatus: 'Все статусы',
    active: 'Активно',
    discontinued: 'Прекращено',
    draft: 'Черновик',
    profit: 'Маржа прибыли',
    searchProducts: 'Поиск товаров...',
    noProducts: 'Товары не найдены',
    addProduct: '+ Добавить товар',
    editProduct: 'Редактировать товар',
    addNewProduct: 'Добавить новый товар',
    actions: 'Действия',
    edit: 'Редактировать',
    delete: 'Удалить',
    cancel: 'Отмена',
    previous: 'Назад',
    next: 'Далее',
    page: 'Страница',
    of: 'из',

    // Orders Page
    manageAllOrders: 'Просмотр и управление всеми заказами клиентов',
    manageOrders: 'Отслеживайте заказы, обрабатывайте возвраты, создавайте ручные заказы',
    orderId: 'ID заказа',
    customer: 'Клиент',
    amount: 'Сумма',
    status: 'Статус',
    date: 'Дата',
    searchOrders: 'Поиск по ID заказа, email...',
    noOrders: 'Заказы не найдены',
    pendingPayment: 'Ожидающий платеж',
    confirmed: 'Подтверждено',
    shipped: 'Отправлено',
    delivered: 'Доставлено',
    cancelled: 'Отменено',
    refunded: 'Возвращено',
    refund: 'Возврат',
    refundOrder: 'Возврат заказа',
    refundAmount: 'Сумма возврата',
    maxRefund: 'Макс',
    reason: 'Причина',
    selectReason: 'Выбрать причину',
    notes: 'Заметки',
    processRefund: 'Обработать возврат',

    // Customers Page
    manageAllCustomers: 'Просмотр и управление всеми учетными записями клиентов',
    manageCustomers: 'Просмотрите информацию о клиенте и историю заказов',
    email: 'Email',
    phone: 'Телефон',
    lastOrder: 'Последний заказ',
    view: 'Просмотр',
    searchCustomers: 'Поиск по email, имени, телефону...',
    noCustomers: 'Клиенты не найдены',
    customerInfo: 'Информация о клиенте',
    createdAt: 'Член с',
    lastLogin: 'Последний вход',
    totalSpent: 'Всего потрачено',
    avgOrderValue: 'Средний заказ',
    memberStatus: 'Статус',
    addresses: 'Адреса',
    orderHistory: 'История заказов',
    close: 'Закрыть',

    // Finance Page
    viewFinancialData: 'Отслеживайте транзакции и финансовые отчеты',
    manageFinance: 'Просмотр транзакций, отчетов P&L, бухгалтерского учета',
    netRevenue: 'Чистый доход',
    afterRefunds: 'После возвратов',
    grossProfit: 'Валовая прибыль',
    margin: 'маржа',
    netProfit: 'Чистая прибыль',
    roi: 'ROI',
    topProductsByRevenue: 'Лучшие товары по доходу',
    unitsSold: 'единиц продано',
    transactionFilters: 'Фильтры транзакций',
    dateFrom: 'От даты',
    dateTo: 'До даты',
    successful: 'Успешно',
    pending: 'Ожидающие',
    failed: 'Неудачно',
    type: 'Тип',
    searchTransactions: 'Поиск транзакций...',
    noTransactions: 'Транзакции не найдены',

    // Reconciliation Page
    detectAndResolveIssues: 'Обнаруживайте и устраняйте несоответствия в инвентаре, платежах и заказах',
    manageReconciliation: 'Обнаружение несоответствий, запуск аудитов',
    openIssues: 'Открытые проблемы',
    critical: 'Критическое',
    warnings: 'Предупреждения',
    info: 'Информация',
    allSeverity: 'Все уровни серьезности',
    noIssuesFound: 'Проблемы не найдены',
    resolveMismatch: 'Разрешить несоответствие',
    issue: 'Проблема',
    expected: 'Ожидается',
    actual: 'Фактическое',
    difference: 'Разница',
    detected: 'Обнаружено',
    product: 'Товар',
    resolve: 'Разрешить',
    selectAction: 'Выбрать действие',
    confirm: 'Подтвердить',
    resolved: 'Разрешено',
    ignored: 'Проигнорировано',

    // Admin User Management
    manageAdmins: 'Управление администраторами',
    adminUsers: 'Пользователи-администраторы',
    promoteUser: 'Повысить до администратора',
    demoteUser: 'Понизить до пользователя',
    viewDetails: 'Просмотр деталей',
    searchByEmail: 'Поиск по электронной почте или имени...',
    filterByRole: 'Фильтр по роли',
    allRoles: 'Все роли',
    roleAdmin: 'Администратор',
    roleSuperadmin: 'Суперадминистратор',
    dateAssigned: 'Дата назначения',
    assignedBy: 'Назначено',
    confirmDemote: 'Подтвердить понижение',
    demoteWarning: 'Этот пользователь потеряет весь доступ администратора и разрешения. Это действие невозможно отменить.',
    noAdminsFound: 'Пользователи-администраторы не найдены',
    selectTargetRole: 'Выберите целевую роль',
    promoteReason: 'Причина повышения (опционально)',
    demoteReason: 'Причина понижения (опционально)',
    statusHistory: 'История статуса',
    promotedOn: 'Повышено',
    demotedOn: 'Понижено',
    userNotFound: 'Пользователь не найден',
    alreadyAdmin: 'Этот пользователь уже администратор',
    promoteSuccess: 'Пользователь успешно повышен',
    demoteSuccess: 'Пользователь успешно понижен',
    backToDashboard: '← Вернуться на панель',

    // Common
    loading: 'Загрузка...',
    error: 'Ошибка загрузки',
    units: 'единицы',
  },
  shipment: {
    paymentReceived: 'Оплата получена!', // TODO: professional translation
    paymentFailed: 'Оплата не прошла',
    paymentFailedDesc: 'Не удалось обработать оплату. Пожалуйста, попробуйте ещё раз.',
    retryPayment: 'Повторить оплату',
    creatingShipment: 'Создаётся отправление...',
    creatingShipmentDesc: 'Мы готовим ваш заказ к отправке (обычно 5–30 секунд).',
    checkingStatus: 'Проверка статуса...',
    checkingStatusDesc: 'Проверяем у нашего партнёра по логистике. Должно завершиться в течение 5 минут.',
    delayedDesc: 'Мы готовим вашу отправку. Спасибо за терпение.',
    shipmentFailed: 'Не удалось создать отправление',
    shipmentFailedDesc: 'Ваше отправление не может быть создано прямо сейчас. Наша команда рассмотрит это.',
    permanentFailed: 'Заказ требует внимания',
    permanentFailedDesc: 'Не удалось создать отправление после нескольких попыток. Обратитесь в поддержку.',
    contactSupport: 'Связаться с поддержкой',
    shipmentCreated: 'Ваш заказ отправлен!',
    shipmentCreatedDesc: 'Ваша посылка в пути. Отследите её ниже.',
    awbCode: 'Код AWB',
    courier: 'Курьер',
    trackingStatus: 'Статус',
    viewTracking: 'Отслеживать в реальном времени →',
    estimatedDelivery: 'Ожидаемая доставка',
    inTransit: 'В пути',
    inTransitDesc: 'Ваша посылка направляется к вам.',
    outForDelivery: 'Передана курьеру',
    outForDeliveryDesc: 'Ваша посылка прибудет сегодня!',
    delivered: 'Доставлено!',
    deliveredDesc: 'Ваш заказ доставлен. Спасибо за покупку!',
    trackOrder: 'Отследить заказ',
    shopAgain: 'Купить ещё',
    orderConfirmedNote: 'Оплата подтверждена, заказ принят.',
    pollingNote: 'Страница обновляется автоматически — обновлять не нужно.',
    retryShipment: 'Повторить отправку',
  },
  orderConfirmation: {
    title: 'Заказ подтверждён!',
    subtitle: 'Спасибо за покупку. Ваш заказ подтверждён.',
    orderId: 'Номер заказа',
    orderDate: 'Дата заказа',
    total: 'Итоговая сумма',
    items: 'Товары',
    shippingAddress: 'Адрес доставки',
    priceSummary: 'Сводка цен',
    subtotal: 'Подытог',
    shipping: 'Доставка',
    free: 'Бесплатно',
    tax: 'Налог (18% GST)',
    confirmationEmail: 'Подтверждение по email',
    confirmationEmailDesc: 'Письмо с подтверждением отправлено на',
    whatsNext: 'Что дальше?',
    orderConfirmedStep: 'Заказ подтверждён',
    preparingStep: 'Подготовка',
    shippedStep: 'Отправлен',
    deliveredStep: 'Доставлен',
    viewOrderHistory: 'История заказов',
    continueShopping: 'Продолжить покупки',
    viewReceipt: 'Посмотреть квитанцию', // TODO: professional translation
    guestPrompt: 'Создайте аккаунт для отслеживания заказа', // TODO: professional translation
    guestPromptDesc: 'Зарегистрируйтесь, чтобы просматривать историю заказов, отслеживать доставку и повторять заказы одним кликом.', // TODO: professional translation
    guestPromptCta: 'Создать аккаунт', // TODO: professional translation
  },
  orderDetails: {
    title: 'Заказ',
    orderedOn: 'Дата заказа',
    orderTimeline: 'История заказа',
    orderStatus: 'Текущий статус',
    orderSummary: 'Сводка заказа',
    itemsOrdered: 'Товары',
    shippingAddress: 'Адрес доставки',
    shipmentInfo: 'Информация об отправлении',
    awbCode: 'Код AWB',
    courier: 'Курьер',
    tracking: 'Отслеживание',
    viewTracking: 'Отследить посылку',
    estDelivery: 'Ожидаемая доставка',
    subtotal: 'Подытог',
    shipping: 'Доставка',
    free: 'Бесплатно',
    tax: 'Налог',
    total: 'Итого',
    printInvoice: 'Распечатать счёт',
    viewReceipt: 'Посмотреть квитанцию', // TODO: professional translation
    reorder: 'Повторить заказ',
    helpSupport: 'Помощь и поддержка',
    needHelp: 'Нужна помощь с заказом?',
    contactSupport: 'Связаться с поддержкой',
    backToOrders: 'К заказам',
    quantity: 'Количество',
    price: 'Цена',
    loadingOrder: 'Загрузка деталей заказа...',
    orderNotFound: 'Заказ не найден.',
    failedToLoad: 'Не удалось загрузить детали заказа.',
  },
  adminShipment: { // TODO: professional translation
    shipmentStatusCol: 'Отправление',
    awbCol: 'AWB / Курьер',
    filterAll: 'Все отправления',
    filterProcessing: 'Обработка',
    filterRetrying: 'Повтор',
    filterFailed: 'Ошибка',
    filterShipped: 'Отправлено',
    filterNotStarted: 'Не начато',
    failedShipmentsAlert: 'Неудачные отправления — нажмите для фильтрации',
    awbPending: 'Ожидание',
    expandTitle: 'Просмотр деталей отправления',
    retryButton: 'Повторить отправление',
    retryButtonTitle: 'Принудительный повтор создания отправления через очередь администратора',
    retryInFlight: 'В очереди…',
    retryQueuedToast: 'Повтор добавлен в очередь — обновите через несколько секунд.',
    retryModalTitle: 'Повторить отправление',
    retryModalSubtitle: 'Это добавит новую попытку создания отправления в очередь. Результат асинхронный.',
    retryOrderId: 'ID заказа',
    retryReason: 'Причина повтора',
    optional: 'необязательно',
    retryReasonPlaceholder: 'напр. Адрес подтверждён, проблема с курьером решена…',
    retryConfirm: 'Добавить в очередь',
    retryInProgress: 'Добавление…',
    retryAsyncNote: '⚡ Повтор асинхронный — создание отправления происходит в фоне.',
    retryQueued: 'Повтор успешно добавлен в очередь.',
    retryAlreadyCreated: 'Это отправление уже было успешно создано.',
    retryRateLimit: 'Превышен лимит запросов. Подождите немного.',
    retryServiceUnavailable: 'Служба отправлений временно недоступна.',
    retryNotReady: 'Заказ ещё не готов к повтору.',
    retryError: 'Не удалось добавить повтор в очередь.',
    close: 'Закрыть',
    cancel: 'Отмена',
    detailSectionTitle: 'Детали отправления',
    detailStatus: 'Статус',
    detailShipmentId: 'ID отправления',
    detailAwb: 'Код AWB',
    detailCourier: 'Курьер',
    detailTracking: 'URL отслеживания',
    trackLink: 'Отследить посылку',
    detailShippingStatus: 'Статус доставки',
    detailEdd: 'Ожид. доставка',
    detailAsyncNote: '⚡ Отправление создаётся асинхронно — данные обновятся после завершения фоновой задачи.',
    noShipmentData: 'Данных об отправлении пока нет.',
  },
  adminMonitor: { // TODO: professional translation
    title: 'Монитор Отправлений',
    subtitle: 'Панель оперативного управления в реальном времени — выявление и устранение проблем',
    navTitle: 'Монитор Отправлений',
    navDesc: 'Операции с отправлениями в реальном времени — сбои, зависшие заказы, нарушения SLA',
    metricProcessing: 'Обработка',
    metricRetrying: 'Повтор',
    metricFailed: 'Окончательный сбой',
    metricCompleted: 'Отправлено сегодня',
    metricStuck: 'Зависло (>10 мин)',
    metricSlaBreach: 'Нарушение SLA',
    alertsTitle: 'Требует внимания',
    alertStuck: 'Зависший заказ',
    alertSla: 'Нарушение SLA',
    alertFailed: 'Окончательный сбой',
    noAlerts: 'Критических проблем нет — все отправления в порядке',
    filterAll: 'Все',
    filterProcessing: 'Обработка',
    filterRetrying: 'Повтор',
    filterFailed: 'Сбой',
    filterShipped: 'Отправлено',
    filterStuck: 'Зависшие',
    filterSlaBreach: 'Нарушение SLA',
    filterNeedsAttention: 'Требует внимания',
    timeFilter1h: 'Последний 1ч',
    timeFilter24h: 'Последние 24ч',
    timeFilterAll: 'Всё время',
    colOrderId: 'ID заказа',
    colCustomer: 'Клиент',
    colPayment: 'Оплата',
    colShipment: 'Отправление',
    colAwb: 'AWB',
    colFailureReason: 'Причина сбоя',
    colDuration: 'Длительность',
    colSla: 'Срок SLA',
    colActions: 'Действия',
    awbPending: 'Ожидание',
    noOrders: 'Нет заказов, соответствующих фильтрам.',
    noShipmentData: 'Данных об отправлении нет.',
    detailTitle: 'Полная запись об отправлении',
    trackLink: 'Открыть отслеживание',
    autoRefresh: 'Авто-обновление',
    autoRefreshOn: 'ВКЛ',
    autoRefreshOff: 'ВЫКЛ',
    lastUpdated: 'Последнее обновление',
    manualRefresh: 'Обновить сейчас',
    refreshing: 'Обновление…',
    actionRetry: 'Повторить',
    actionDetails: 'Детали',
    retryModalTitle: 'Повторить отправление',
    retryModalSubtitle: 'Поставить новую попытку создания отправления в очередь (async — проверьте через ~30с)',
    retryOrderId: 'ID заказа',
    retryReason: 'Причина повтора',
    optional: 'необязательно',
    retryReasonPlaceholder: 'напр. Адрес подтверждён, проблема с курьером решена…',
    retryConfirm: 'В очередь',
    retryInProgress: 'Постановка в очередь…',
    cancel: 'Отмена',
    close: 'Закрыть',
    retryQueued: 'Повтор в очереди — обновите через несколько секунд.',
    retryQueuedToast: 'Повтор в очереди — обновите для просмотра статуса.',
    retryAlreadyCreated: 'Отправление уже создано. Обновите для актуального статуса.',
    retryRateLimit: 'Превышен лимит — подождите перед повтором.',
    retryServiceUnavailable: 'Служба отправлений недоступна. Попробуйте позже.',
    retryError: 'Ошибка повтора. Попробуйте снова.',
    retryNotReady: 'Заказ ещё не готов к повтору.',
    retryAsyncNote: '⚡ Повтор асинхронный — заказ обновится в течение 30 секунд.',
  },
  reconciliationMonitor: { // TODO: professional translation
    title: 'Монитор Сверки',
    subtitle: 'Панель целостности данных в реальном времени — обнаружение несоответствий платежей, заказов и отправлений',
    navTitle: 'Монитор Сверки',
    navDesc: 'Мониторинг целостности данных в реальном времени — осиротевшие платежи, зависшие заказы, неудавшиеся сверки',
    metricOrphaned: 'Осиротевшие Платежи',
    metricOrphanedTitle: 'Платёж прошёл, но отправление не создано (>15 мин)',
    metricFailedReconciling: 'Сбой Сверки',
    metricFailedReconcilingTitle: 'Создание отправления повторяется',
    metricPermanentFailed: 'Постоянный Сбой',
    metricPermanentFailedTitle: 'Все попытки повтора исчерпаны',
    metricStuck: 'Зависший (>10 мин)',
    metricStuckTitle: 'Обработка дольше порогового значения',
    metricSlaBreach: 'Нарушение SLA',
    metricSlaBreachTitle: 'Срок истёк, не завершено',
    metricReconciled: 'Исправлено Сегодня',
    metricReconciledTitle: 'Успешно завершено за последние 24ч',
    alertsTitle: 'Критические Проблемы — Требуется Немедленное Внимание',
    noAlerts: 'Нет критических проблем с целостностью данных — все системы согласованы',
    alertsOverflow: '+{n} ещё — используйте фильтры ниже для просмотра всех',
    autoRefresh: 'Авто-обновление',
    autoRefreshOn: 'ВКЛ',
    autoRefreshOff: 'ВЫКЛ',
    lastUpdated: 'Последнее обновление',
    manualRefresh: 'Обновить сейчас',
    refreshing: 'Обновление…',
    runReconciliation: 'Запустить сверку',
    reconRunning: 'Выполняется…',
    reconciliationTriggered: '✓ Сверка запущена — результаты появятся в ближайшее время',
    exportCsv: 'Экспорт CSV',
    actionView: 'Посмотреть',
    actionRetry: 'Повторить',
    actionReconcile: 'Сверить',
    filterLabel: 'Фильтр:',
    filterAll: 'Все',
    filterOrphaned: 'Осиротевшие платежи',
    filterFailedReconciling: 'Повтор',
    filterPermanentFailed: 'Постоянный сбой',
    filterStuck: 'Зависший',
    filterSlaBreach: 'Нарушение SLA',
    filterNeedsAttention: 'Требует внимания',
    timeFilter1h: 'Последний 1ч',
    timeFilter24h: 'Последние 24ч',
    timeFilterAll: 'Всё время',
    colOrderId: 'ID Заказа',
    colPayment: 'Платёж',
    colShipment: 'Отправление',
    colIssueType: 'Тип проблемы',
    colDuration: 'Обработка',
    colSla: 'Срок SLA',
    colLastUpdated: 'Последн. обновл.',
    colActions: 'Действия',
    noOrders: 'Нет заказов, соответствующих текущим фильтрам.',
    noShipmentData: 'Нет данных об отправлении.',
    detailTitle: 'Полная Запись',
    selectedOrders: 'заказов выбрано',
    bulkRetry: 'Повторить все выбранные',
    bulkRetrying: 'Постановка в очередь…',
    clearSelection: 'Сбросить',
    // Tabs
    tabHealth: '🟢 Живой мониторинг', // TODO: professional translation
    tabMismatches: '🔎 Несоответствия', // TODO: professional translation
  },
  receipt: {
    title: 'Квитанция', // TODO: professional translation
    receiptNumber: 'Квитанция №',
    issuedDate: 'Выдано',
    orderId: 'ID заказа',
    customerInfo: 'Покупатель',
    billingAddress: 'Адрес выставления счёта',
    orderItems: 'Товары заказа',
    columnProduct: 'Товар',
    columnQty: 'Кол-во',
    columnUnit: 'Цена за ед.',
    columnTotal: 'Итого',
    subtotal: 'Подытог',
    tax: 'Налог',
    shipping: 'Доставка',
    total: 'Итого',
    free: 'Бесплатно',
    paymentInfo: 'Оплата',
    paymentMethod: 'Способ',
    paymentId: 'ID платежа',
    paymentStatus: 'Статус',
    paid: 'Оплачено',
    printReceipt: 'Распечатать квитанцию',
    downloadPdf: 'Скачать PDF',
    backToOrder: 'Назад к заказу',
    currency: '₹',
    loading: 'Загрузка квитанции…', // TODO: professional translation
    errorTitle: 'Не удалось загрузить квитанцию', // TODO: professional translation
    errorNotFound: 'Эта квитанция недоступна. Возможно, заказ ещё не оплачен.', // TODO: professional translation
    errorForbidden: 'У вас нет прав для просмотра этой квитанции.', // TODO: professional translation
    errorRateLimit: 'Слишком много запросов — пожалуйста, подождите немного и попробуйте снова.', // TODO: professional translation
    errorGeneric: 'Что-то пошло не так. Пожалуйста, попробуйте снова.', // TODO: professional translation
    pdfError: 'Ошибка загрузки PDF. Пожалуйста, попробуйте снова.', // TODO: professional translation
    pdfRateLimit: 'Слишком много запросов — подождите немного перед загрузкой.', // TODO: professional translation
    tryAgain: 'Попробовать снова', // TODO: professional translation
  },
};

export default ru;
